/** 注意 admin / client 多端同步更新 */
type ImageFileType = "webp" | "jpeg" | "png";
const imgExtensions = ["png", "webp", "jpg", "jpeg", "bmp"];
var webpSupported: undefined | boolean = undefined;
/** 将图片文件转换成webp格的图片文件
 * 传入非图片文件，直接返回
 * @param imgFile 文件对象，可能<input  type="file"/>中获取
 * @param maxWidthOrHeight 图像最大宽度或高度，-1 表示不处理
 * @returns WebP 格式图片文件
 */
export async function imageFileToWebp(imgFile: File, maxWidthOrHeight: number = -1): Promise<File> {
    if (imgFile.type == "image/webp") return imgFile;
    if (!imgFile.type.startsWith("image/")) return imgFile; // 非图片文件
    // if (maxWidthOrHeight <= 0) return imgFile;
    if (typeof webpSupported == "undefined") webpSupported = await testCanvarWebpSupport();

    const imgTask = new Promise<HTMLImageElement>((cb, fail) => {
        const img = new Image();
        img.onload = () => cb(img);
        img.onerror = () => fail(new Error("照片加载失败！"))
        img.src = URL.createObjectURL(imgFile);
    })

    var canvas = document.createElement('canvas');
    var ctx = canvas.getContext('2d');
    if (!ctx) throw new Error("getContext 2D is null?");

    const img = await imgTask;
    var size = getScaledSize(img.width, img.height, maxWidthOrHeight);

    canvas.width = size.width;
    canvas.height = size.height;
    ctx.drawImage(img, 0, 0, size.width, size.height);

    URL.revokeObjectURL(img.src)
    var blob: Blob | undefined = undefined;
    var fileType: ImageFileType = "webp"

    if (webpSupported) blob = await canvasToBlob(canvas, fileType = "webp");
    if (!blob) blob = await canvasToBlob(canvas, fileType = "jpeg");
    if (!blob) throw new Error("Canvas 导出图片失败");

    var idx = imgFile.name.lastIndexOf(".");
    var fName = (idx == -1) ? imgFile.name : imgFile.name.substring(0, idx);
    fName = fName.concat(".".concat(fileType));
    const file = new File([blob], fName, { type: "image/".concat(fileType) })
    return file;
}

/** 根据宽高比，缩小尺寸 */
function getScaledSize(width: number, height: number, maxWidthOrHeight: number): { width: number, height: number } {
    if (maxWidthOrHeight <= 0 || Math.max(width, height) <= maxWidthOrHeight) return { width, height };
    if (width > height) {
        height = Math.floor(height / width * maxWidthOrHeight);
        width = maxWidthOrHeight;
    } else {
        width = Math.floor(width / height * maxWidthOrHeight)
        height = maxWidthOrHeight;
    }
    return { width, height };
}


function canvasToBlob(canvas: HTMLCanvasElement, type: ImageFileType): Promise<Blob | undefined> {
    const FILE_TYPE = "image/".concat(type);
    return new Promise<Blob | undefined>((cb, fail) => {
        canvas.toBlob(b => {
            if (!b) return fail(new Error("Canvas to blob fail"));
            //console.error("target", FILE_TYPE, "dest", b.type)
            cb(b.type.includes(type) ? b : undefined);
        }, FILE_TYPE)
    });
}

/** 检测 canvas 是否支持 webp 格式输出 */
export function testCanvarWebpSupport(): Promise<boolean> {
    console.error("webp test")
    return new Promise<boolean>((cb, fail) => {
        const FILE_TYPE = "image/webp";
        var canvas = document.createElement('canvas');
        canvas.width = 1;
        canvas.height = 1;
        canvas.toBlob(b => {
            if (!b) return fail(new Error("canvas to blob fail"));
            cb(b.type.includes("webp"));
        }, FILE_TYPE)
    });
}

/**根据文扩展名检查是否为图片 */
export function isImageFile(fName: string): boolean {
    if (!fName) return false;
    const idx = fName.lastIndexOf('.') + 1;
    if (!idx) return false;
    const ext = fName.substring(idx).toLocaleLowerCase();
    return imgExtensions.includes(ext);
}

export async function imageToPng(img: HTMLImageElement, maxWidthOrHeight: number): Promise<Blob>;
export async function imageToPng(imgUrl: string, maxWidthOrHeight: number): Promise<Blob>;
export async function imageToPng(imgOrUrl: HTMLImageElement | string, maxWidthOrHeight: number = 0) {

    const imgTask = new Promise<HTMLImageElement>((cb, fail) => {
        if (typeof (imgOrUrl) != "string") return cb(imgOrUrl);
        const img = new Image();
        img.onload = () => cb(img);
        img.onerror = () => fail(new Error("照片加载失败！"))
        img.src = imgOrUrl;
    })
    const img = await imgTask;

    var canvas = document.createElement('canvas');
    var ctx = canvas.getContext('2d');
    if (!ctx) throw new Error("getContext 2D is null?");
    var size = getScaledSize(img.width, img.height, maxWidthOrHeight);

    canvas.width = size.width;
    canvas.height = size.height;
    ctx.drawImage(img, 0, 0, size.width, size.height);

    try {
        return await canvasToBlob(canvas, "png");
    } finally {
        ctx.clearRect(0, 0, size.width, size.height);
    }
}